export default __webpack_public_path__ + "8075f7e865611fdcf9c3aaadd7c8a298.svg";